import UsersAvatarWithText from './UsersAvatarWithText';

export default UsersAvatarWithText;
